import envConfig from './config.production';

const config = {
  ...envConfig,
};

export default config;
